import './index.css'
import { sanitize } from '@disco/utils/string-utils'
import clsx from 'clsx'

import React, { Component } from 'react'
import { convertBreakCharsToLineBreaks } from 'utils/dom'
import Button from 'components/ui/button'

const truncateText = (text, trimLength) => {
  // Let the browser autoclose open html tags
  const div = document.createElement('div')
  div.innerHTML = text.substr(0, trimLength) + '...'
  return div.innerHTML
}

type Props = {
  message: string
  className?: string
  trimLength: number
  maxLengthBeforeTrim: number
  expanded?: boolean
  isHtml?: boolean
  CustomButton?: (...args: Array<any>) => any
  inlineButton?: boolean
}
export default class PlaylistMessage extends Component<
  Props,
  {
    read_more_version: boolean
    message_expanded: boolean
  }
> {
  constructor(props: Props) {
    super(props)
    this.state = {
      read_more_version: props.message
        ? props.message.length > props.maxLengthBeforeTrim
        : false,
      message_expanded: props.expanded || false,
    }
  }

  _toggleReadMore: (event: React.SyntheticEvent<EventTarget>) => void = (
    event: React.SyntheticEvent<any>,
  ) => {
    event.preventDefault()
    this.setState(prevState => ({
      message_expanded: !prevState.message_expanded,
    }))
  }

  render(): null | React.ReactElement<'div'> {
    const { className, message } = this.props
    const { read_more_version } = this.state
    if (!message || !message.trim().length) return null
    return (
      <div className={className}>
        {read_more_version
          ? this._renderReadMoreVersion()
          : this._renderMessage(message)}
      </div>
    )
  }

  _renderMessage(
    message: string,
  ): React.ReactElement<'div'> | Array<React.ReactNode> {
    const { isHtml, inlineButton } = this.props
    return isHtml ? (
      <div
        className={clsx({
          'PlaylistMessageContent--Inline': inlineButton,
        })}
        dangerouslySetInnerHTML={{
          __html: sanitize(message, true),
        }}
      />
    ) : (
      convertBreakCharsToLineBreaks(message)
    )
  }

  _renderReadMoreVersion(): React.ReactNode {
    const { message, trimLength, CustomButton } = this.props
    const { message_expanded } = this.state
    const output = message_expanded
      ? message
      : truncateText(message, trimLength)
    const ButtonElement = CustomButton || Button
    return (
      <React.Fragment>
        {this._renderMessage(output)}
        <ButtonElement
          appearance="inline-link"
          onClick={this._toggleReadMore}
          caption={message_expanded ? 'Read less' : 'Read more'}
        />
      </React.Fragment>
    )
  }
}
